import CartService from '../Service/CartService'
import ToastService from '../Service/ToastService'
import CartButton from './CartButton'
import CartDialog from './CartDialog'

const cartButton = new CartButton()
cartButton.init()

const cartDialog = new CartDialog()
cartDialog.init()

CartService.initLifecycle()
void CartService.hydrate()

Object.assign(window as unknown as Record<string, unknown>, { CartService, ToastService })
